import { formatDateUtil } from "@utils/date.util";
import { PRIMARY_KEY } from "@constants/app.constants";

const tableTitle = "Products List";
const keyColumn = PRIMARY_KEY;
const menuUrl = "products";
const tableColumn = [
  {
    id: "image",
    numeric: false,
    disablePadding: false,
    label: "Image",
    type: "FILE_UPLOAD",
    formatData: (data) => {
      return (
        <img
          src={data}
          alt=" Image"
          style={{ width: "100px", height: "50px" }}
        />
      );
    },
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "slug",
    numeric: false,
    disablePadding: false,
    label: "Slug",
  },
  // {
  //   id: "description",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Description",
  // },
  // {
  //   id: "price",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Price",
  // },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    isBadge: true,
    primaryKey: keyColumn,
    badgeText: {
      1: "Enabled",
      0: "Disabled",
    },
    badgeColor: {
      1: "success",
      0: "danger",
    },
  },
  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDateUtil,
  },
];
const breadCrumbs = [{ name: "Products", menu_url: "/products" }];

const filters = [
  {
    name: "status",
    id: "status",
    label: "Status",
    value: "",
    type: "SELECT",
    placeholder: "Select Status",
    options: [
      { name: "Enabled", value: "1" },
      { name: "Disabled", value: "0" },
    ],
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
};
